export const ERROR = 'error';
export const MARKETING = 'marketing';
export const WARNING = 'warning';
export const SUCCESS = 'success';
export const INFO = 'info';

// new styles
export const INVASIVE_UPDATE_ROYAL_BLUE = 'invasive-update-royal-blue';

export const TOAST_MESSAGE_DURATION = 4000;
